import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { FcOutlinedMultiSelectModule } from '../../base/fc-outlined-milti-select/fc-outlined-select.module';
import { FcMaintenanceTypesOutlinedSelectComponent } from './fc-maintenance-types-outlined-select.component';
import { FcMaintenanceTypesOutlinedSelectService } from './services/fc-maintenance-types-outlined-select.service';

@NgModule({
  declarations: [
    FcMaintenanceTypesOutlinedSelectComponent
  ],
  imports: [
    CommonModule,
    FuseSharedModule,
    FcOutlinedMultiSelectModule
  ],
  providers: [
    FcMaintenanceTypesOutlinedSelectService
  ],
  exports: [
    FcMaintenanceTypesOutlinedSelectComponent
  ]
})
export class FcMaintenanceTypesOutlinedSelectModule { }
